/* =========================================================
   SAFE WISHLIST (Prestige-friendly)
   - No stopPropagation
   - No capture-phase listeners
   - Only handles intended wishlist buttons
   ========================================================= */

(function () {
  const KEY = "me:wishlist_handles";

  // -------------------------
  // Storage helpers
  // -------------------------
  function read() {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(v) ? v.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    const clean = Array.from(new Set((list || []).filter(Boolean)));
    localStorage.setItem(KEY, JSON.stringify(clean));
    return clean;
  }

  // -------------------------
  // UI helpers
  // -------------------------
  function setHeartState(btn, active) {
    btn.classList.toggle("is-active", !!active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    btn.setAttribute("aria-label", active ? "Remove from wishlist" : "Add to wishlist");
  }

  function getHandleFromHeart(btn) {
    return (btn && btn.getAttribute("data-wishlist-handle")) || "";
  }

  function syncHearts(root) {
    const list = read();
    (root || document)
      .querySelectorAll("button.wishlist-heart[data-wishlist-handle]")
      .forEach((btn) => {
        const h = getHandleFromHeart(btn);
        if (!h) return;
        setHeartState(btn, list.includes(h));
      });
  }

  function updateHeaderCount() {
    // You’re using: Wishlist (<span id="wishlist-count-inline">0</span>)
    const el = document.getElementById("wishlist-count-inline");
    if (!el) return;
    const count = read().length;
    el.textContent = String(count);
    
    // Update wishlist dot visibility
    const dot = document.getElementById("wishlist-dot");
    if (dot) {
      dot.classList.toggle("is-visible", count > 0);
    }
  }

  function broadcast() {
    window.dispatchEvent(new CustomEvent("me:wishlist:updated"));
  }

  // -------------------------
  // Wishlist actions
  // -------------------------
  function toggleHeart(btn) {
    const handle = getHandleFromHeart(btn);
    if (!handle) return;

    const list = read();
    const idx = list.indexOf(handle);

    let next;
    if (idx > -1) {
      next = list.filter((h) => h !== handle);
      setHeartState(btn, false);
    } else {
      next = list.concat([handle]);
      setHeartState(btn, true);
    }

    write(next);
    updateHeaderCount();
    broadcast();
  }

  function removeHandle(handle) {
    if (!handle) return;
    const next = write(read().filter((h) => h !== handle));
    updateHeaderCount();
    broadcast();
    return next;
  }

  async function addToCart(variantId, qty) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 }),
    });

    if (!res.ok) {
      let msg = "Could not add to bag.";
      try {
        const data = await res.json();
        if (data && (data.description || data.message)) msg = data.description || data.message;
      } catch (e) {}
      throw new Error(msg);
    }

    return await res.json();
  }

  // -------------------------
  // Event bindings (SAFE)
  // -------------------------
  document.addEventListener("click", async function (e) {
    // 1) Heart toggle (PDP/PLP)
    const heartBtn = e.target.closest("button.wishlist-heart[data-wishlist-handle]");
    if (heartBtn) {
      e.preventDefault();
      toggleHeart(heartBtn);
      return;
    }

    // 2) Wishlist page remove
    const removeBtn = e.target.closest("[data-wishlist-remove]");
    if (removeBtn) {
      e.preventDefault();
      const handle = removeBtn.getAttribute("data-wishlist-remove") || "";

      removeHandle(handle);

      // If the button sits inside a card, remove it from DOM immediately
      const card = removeBtn.closest("[data-handle]");
      if (card) card.remove();

      return;
    }

    // 3) Wishlist page Move to Bag
    const atcBtn = e.target.closest("[data-wishlist-atc]");
    if (atcBtn) {
      e.preventDefault();

      const variantId = atcBtn.getAttribute("data-wishlist-atc");
      if (!variantId) return;

      const original = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = "ADDING…";

      try {
        await addToCart(variantId, 1);

        atcBtn.textContent = "ADDED";
        // Prestige themes commonly refresh cart UI from their own listeners
        window.dispatchEvent(new CustomEvent("cart:refresh"));
      } catch (err) {
        atcBtn.textContent = original;
        atcBtn.disabled = false;
        alert(err.message || "Could not add to bag.");
        return;
      }

      setTimeout(() => {
        atcBtn.textContent = original;
        atcBtn.disabled = false;
      }, 900);

      return;
    }
  });

  // Init / resync hooks
  function init() {
    syncHearts(document);
    updateHeaderCount();
  }

  document.addEventListener("DOMContentLoaded", init);

  document.addEventListener("shopify:section:load", function (e) {
    syncHearts(e.target || document);
    updateHeaderCount();
  });

  document.addEventListener("shopify:section:reorder", function () {
    syncHearts(document);
    updateHeaderCount();
  });

  window.addEventListener("me:wishlist:updated", function () {
    syncHearts(document);
    updateHeaderCount();
  });

  // Light observer for infinite scroll / dynamic content
  const obs = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (m.type !== "childList" || !m.addedNodes || !m.addedNodes.length) continue;

      const hit = Array.from(m.addedNodes).some((n) => {
        return (
          n &&
          n.nodeType === 1 &&
          (n.matches?.("button.wishlist-heart") ||
            n.querySelector?.("button.wishlist-heart") ||
            n.matches?.("[data-wishlist-atc]") ||
            n.querySelector?.("[data-wishlist-atc]") ||
            n.matches?.("[data-wishlist-remove]") ||
            n.querySelector?.("[data-wishlist-remove]"))
        );
      });

      if (hit) {
        syncHearts(document);
        updateHeaderCount();
        break;
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();